import { verticalAlignToFlex } from "../utils/editorFieldUtils";
import { cellGapPaddingPx } from "./cellStyleUtils";

/** Editor-only chrome: fills the table cell; dashed outline does not affect inner box size. */
export const cellChromeEditorSx = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  minHeight: "100%",
  boxSizing: "border-box",
  margin: 0,
  border: "none",
  outline: "1px dashed #cbd5e1",
  outlineOffset: -1,
};

/** Outer shell between td and inner cell box: gap padding + editor chrome. */
export const cellShellSx = (cellGap, chromeOutline) => {
  const pad = cellGapPaddingPx(cellGap);
  return {
    ...cellChromeEditorSx,
    padding: pad > 0 ? `${pad}px` : 0,
    outline: chromeOutline || cellChromeEditorSx.outline,
  };
};

export const cellTableShellSx = {
  p: 0,
  m: 0,
  position: "relative",
  height: "100%",
  verticalAlign: "top",
};

/** Flex layout inside the bordered inner cell (vertical content alignment). */
export const cellInnerLayoutSx = (columnProps) => ({
  justifyContent: verticalAlignToFlex(columnProps?.contentVAlign || "top"),
  flex: "1 1 auto",
  minHeight: 0,
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
});

export const cellInnerContentSx = {
  width: "100%",
  flex: "1 1 auto",
  minHeight: 0,
  height: "100%",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
};

/** Slot for component/nested grid: stretches to full inner cell height. */
export const cellComponentSlotSx = {
  flex: "1 1 auto",
  alignSelf: "stretch",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  minHeight: 0,
  height: "100%",
  boxSizing: "border-box",
};

export const componentFillSx = {
  flex: 1,
  width: "100%",
  minHeight: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
};
 